import React, { useEffect, useState } from 'react';
import { EnhancedProductCard } from '../shared/EnhancedProductCard';
import { ClockIcon } from 'lucide-react';
export function OffersFlashSales() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 4,
    minutes: 59,
    seconds: 42
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            hours: prev.hours,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const products = [{
    id: 1,
    name: 'Gold Standard 100% Whey Protein',
    brand: 'OPTIMUM NUTRITION',
    price: 29.99,
    originalPrice: 79.99,
    discount: 62,
    rating: 4.8,
    reviewCount: 324,
    image: 'https://img.innovapharmacy.com/media/catalog/product/4/5/4537b3e3-4206-41fc-b34e-53ddce591f66_1.jpg',
    isBestSeller: true,
    expressDelivery: true,
    endingSoon: true
  }, {
    id: 2,
    name: 'ISO100 Hydrolyzed Protein Powder',
    brand: 'DYMATIZE',
    price: 24.99,
    originalPrice: 59.99,
    discount: 58,
    rating: 4.7,
    reviewCount: 256,
    image: 'https://img.innovapharmacy.com/media/catalog/product/1/0/1015683_1.jpg',
    expressDelivery: true,
    endingSoon: true
  }, {
    id: 3,
    name: 'Original Pre Workout Powder',
    brand: 'C4',
    price: 19.99,
    originalPrice: 39.99,
    discount: 50,
    rating: 4.6,
    reviewCount: 189,
    image: 'https://img.innovapharmacy.com/media/catalog/product/2/1/213099.jpg',
    expressDelivery: true
  }, {
    id: 4,
    name: 'Nitro-Tech Whey Gold Protein',
    brand: 'MUSCLETECH+',
    price: 27.99,
    originalPrice: 64.99,
    discount: 57,
    rating: 4.5,
    reviewCount: 145,
    image: 'https://img.innovapharmacy.com/media/catalog/product/1/0/1030868_1.png',
    expressDelivery: true
  }, {
    id: 5,
    name: 'Syntha-6 Protein Powder',
    brand: 'BSN',
    price: 22.99,
    originalPrice: 54.99,
    discount: 58,
    rating: 4.7,
    reviewCount: 132,
    image: 'https://img.innovapharmacy.com/media/catalog/product/1/0/1000157_1.jpg',
    expressDelivery: true
  }, {
    id: 6,
    name: 'Amino Energy',
    brand: 'OPTIMUM NUTRITION',
    price: 16.99,
    originalPrice: 34.99,
    discount: 51,
    rating: 4.4,
    reviewCount: 98,
    image: 'https://img.innovapharmacy.com/media/catalog/product/4/5/4537b3e3-4206-41fc-b34e-53ddce591f66_1.jpg',
    expressDelivery: true
  }];
  return <div className="container mx-auto px-4 py-6" data-id="element-4438" data-mp="3q9qsjx8u8dr">
      <div className="bg-gradient-to-r from-red-500 to-red-600 rounded-t-xl p-4 md:p-6" data-id="element-4439" data-mp="3uye2e6fzmdid">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between" data-id="element-4440" data-mp="dq0oeuh3p3i2">
          <h2 className="text-2xl md:text-3xl font-bold text-white mb-3 md:mb-0 flex items-center gap-2" data-id="element-4441" data-mp="dno3c8g1qd0s">
            <ClockIcon className="w-6 h-6 animate-pulse" data-id="element-4442" data-mp="3h6qybkft00p1" />
            Flash Sales
          </h2>
          <div className="flex items-center justify-between md:justify-end gap-4" data-id="element-4443" data-mp="3c7o3estjfaus">
            <div className="flex items-center gap-2 bg-white bg-opacity-20 backdrop-blur-sm px-4 py-2 rounded-lg" data-id="element-4444" data-mp="3c5jrbnlhj5jf">
              <div className="text-white font-bold text-lg md:text-xl" data-id="element-4445" data-mp="3m5u3d4vsa6x0">
                {String(timeLeft.hours).padStart(2, '0')}
              </div>
              <span className="text-white" data-id="element-4446" data-mp="2yeyd4c6z7jrv">:</span>
              <div className="text-white font-bold text-lg md:text-xl" data-id="element-4447" data-mp="2th6fd1jnh3fr">
                {String(timeLeft.minutes).padStart(2, '0')}
              </div>
              <span className="text-white" data-id="element-4448" data-mp="1wrckta943jso">:</span>
              <div className="text-white font-bold text-lg md:text-xl" data-id="element-4449" data-mp="20r3i7wt58y66">
                {String(timeLeft.seconds).padStart(2, '0')}
              </div>
            </div>
            <a href="#" className="hidden md:inline-block text-sm font-medium text-white bg-red-700 hover:bg-red-800 px-4 py-2 rounded-full transition-colors whitespace-nowrap" data-id="element-4450" data-mp="25od6va8pl5sy">
              View All
            </a>
          </div>
        </div>
      </div>
      <div className="bg-white rounded-b-xl border border-gray-200 border-t-0 p-4 md:p-6" data-id="element-4451" data-mp="2khgplky1dpl9">
        <div className="hidden md:grid grid-cols-3 lg:grid-cols-6 gap-4" data-id="element-4452" data-mp="2ohqromipjvuu">
          {products.map(product => <EnhancedProductCard key={product.id} product={product} data-id="element-4453" data-mp="2tdob51p9pibu" />)}
        </div>

        <div className="md:hidden -mx-4 px-4 overflow-x-auto scrollbar-hide snap-x snap-mandatory flex gap-3 pb-2" data-id="element-4454" data-mp="u50wm1glsglv">
          {products.map(product => <div key={product.id} className="snap-start flex-shrink-0 w-[42vw]" data-id="element-4455" data-mp="rjjpnw6dbmf9">
              <EnhancedProductCard product={product} data-id="element-4456" data-mp="mri7xuqfl3hu" />
            </div>)}
        </div>
      </div>
    </div>;
}